(function() {
  'use strict';

  const navbar = document.querySelector('[data-navbar]');
  if (navbar) {
    const onScroll = () => {
      if (window.scrollY > 40) { navbar.classList.add('navbar--scrolled'); } else { navbar.classList.remove('navbar--scrolled'); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => { mobileMenu.classList.toggle('navbar__mobile--open'); });
  }

  document.querySelectorAll('[data-scroll-to]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = el.getAttribute('data-scroll-to');
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        if (mobileMenu) mobileMenu.classList.remove('navbar__mobile--open');
      }
    });
  });

  const observerOptions = { threshold: 0.15, rootMargin: '0px 0px -50px 0px' };
  const animationObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const delay = entry.target.getAttribute('data-delay') || 0;
        setTimeout(() => {
          entry.target.classList.add('fade-in--visible', 'fade-in-up--visible', 'fade-in-left--visible', 'fade-in-scale--visible');
        }, parseInt(delay));
        animationObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);
  document.querySelectorAll('.fade-in, .fade-in-up, .fade-in-left, .fade-in-scale').forEach(el => { animationObserver.observe(el); });

  document.querySelectorAll('[data-faq-question]').forEach(btn => {
    btn.addEventListener('click', () => {
      const answer = btn.nextElementSibling;
      const isOpen = answer.classList.contains('faq__answer--open');
      document.querySelectorAll('.faq__answer').forEach(a => a.classList.remove('faq__answer--open'));
      if (!isOpen) answer.classList.add('faq__answer--open');
    });
  });

  const banner = document.querySelector('[data-urgency-banner]');
  if (banner) {
    const getEndOfDay = () => {
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
      if (end.getTime() <= now.getTime()) { end.setDate(end.getDate() + 1); }
      return end.getTime();
    };
    let endTime = getEndOfDay();
    const hoursEl = banner.querySelector('[data-hours]');
    const minutesEl = banner.querySelector('[data-minutes]');
    const secondsEl = banner.querySelector('[data-seconds]');
    const tick = () => {
      let remaining = endTime - Date.now();
      if (remaining <= 0) { endTime = getEndOfDay(); remaining = endTime - Date.now(); }
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    };
    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart-btn]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Wird hinzugefügt...'; btn.disabled = true; }
      try {
        const formData = new FormData(form);
        const response = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/javascript' } });
        if (response.ok) { window.location.href = window.routes.cart_url; } else { if (btn) { btn.textContent = originalText; btn.disabled = false; } }
      } catch(err) { if (btn) { btn.textContent = originalText; btn.disabled = false; } }
    });
  });
})();
